import Vue from 'vue'
import axios from 'axios'

const initState = {}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    loading(state, loading) { this.state.app.loading = loading }
  },
  actions: {
    searchPodcast({ commit }, search) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/search-podcast?term=${search}`)
          .then((res) => resolve(res.data.items))
          .catch((error) => reject(error))
      })
    },
    getAll({ commit }, queries) {
      return new Promise((resolve, reject) => {
        axios
          .get('/landings', { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getStats({ commit }, { params, landingId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/stats`, { params })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllWebhooks({ commit }, { queries, landingId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/webhooks`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllRedirects({ commit }, { queries, landingId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/redirects/all`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllBackupRecords({ commit }, { queries, landingId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/backup-records`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllFiles({ commit }, { queries, landingId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/files`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getForms({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/forms`)
          .then((res) => resolve(res.data.forms))
          .catch((error) => reject(error))
      })
    },
    getMenus({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/menus`)
          .then((res) => resolve(res.data.menus))
          .catch((error) => reject(error))
      })
    },
    getForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${params.landingId}/forms/${params.formId}`)
          .then((res) => resolve(res.data.form))
          .catch((error) => reject(error))
      })
    },
    getMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${params.landingId}/menus/${params.menuId}`)
          .then((res) => resolve(res.data.menu))
          .catch((error) => reject(error))
      })
    },
    getRedirect({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${params.landingId}/redirects/${params.redirectId}`)
          .then((res) => resolve(res.data.redirect))
          .catch((error) => reject(error))
      })
    },
    getFeaturedEpisodes({ commit }, { landingId, count }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/featured-episodes?count=${count}`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getEpisodes({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/episodes`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getCards({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/cards`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getCard({ commit }, { landingId, cardId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/cards/${cardId}`)
          .then((res) => resolve(res.data.card))
          .catch((error) => reject(error))
      })
    },
    getCardIntegrations({ commit }, { landingId, cardId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/cards-integrations`)
          .then((res) => resolve(res.data.integrations))
          .catch((error) => reject(error))
      })
    },
    getCardContacts({ commit }, { landingId, cardId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/cards/${cardId}/contacts`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    deleteCardContact({ commit }, { landingId, cardId, contactId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/cards/${cardId}/contacts/${contactId}`)
          .then((res) => resolve(true))
          .catch((error) => reject(error))
      })
    },
    getCardUsers({ commit }, { landingId, cardId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/cards/${cardId}/users`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    checkCardUserEmail({ commit }, { landingId, cardId, email }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/cards/${cardId}/users/${email}`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    createCardUser({ commit }, { landingId, cardId, user }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/cards/${cardId}/users`, user)
          .then((res) => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteCardUser({ commit }, { landingId, cardId, userId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/cards/${cardId}/users/${userId}`)
          .then((res) => resolve(true))
          .catch((error) => reject(error))
      })
    },
    getCardTransfers({ commit }, { landingId, cardId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/cards/${cardId}/transfers`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    deleteCardTransfer({ commit }, { landingId, cardId, id }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/cards/${cardId}/transfers/${id}`)
          .then((res) => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createCard({ commit }, card) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${card.landing_id}/cards`, card)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    updateCard({ commit }, card) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${card.landing_id}/cards/${card.id}`, card)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    cloneCard({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/cards/${params.id}/clone`, params)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    transferCard({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/cards/${params.id}/transfer`, params)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    deleteCard({ commit }, card) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${card.landing_id}/cards/${card.id}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    getBlogs({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/blogs`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getEpisode({ commit }, { landingId, episodeId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/episodes/${episodeId}`)
          .then((res) => resolve(res.data.episode))
          .catch((error) => reject(error))
      })
    },
    getBlog({ commit }, { landingId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/blogs/${blogId}`)
          .then((res) => resolve(res.data.blog))
          .catch((error) => reject(error))
      })
    },
    getContacts({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/contacts`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getPage({ commit }, { landingId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/pages/${pageId}`)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    getPageByUniqueName({ commit }, { landingId, uniqueName }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/unique-names/${uniqueName}`)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    getPagesList({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/pages/list`, { params: queries })
          .then((res) => resolve(res.data.pages))
          .catch((error) => reject(error))
      })
    },
    getPages({ commit }, { landingId, queries }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/pages`, { params: queries })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    getAllPages({ commit }, { landingId }) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/pages/all`)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    previewPage({ commit }, pageId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/pages/${pageId}/preview`)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    find({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}`)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    findByUniqueId({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/unique-id`)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    findAgencyPageByUniqueId({ commit }, uniqueId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/agency-page/${uniqueId}/unique-id`)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    findAgencyBlogByUniqueId({ commit }, uniqueId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/agency-blog/${uniqueId}/unique-id`)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    create({ commit }, landing) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings`, landing)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    createAuto({ commit }, landing) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/auto`, landing)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    createMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/menus`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/forms`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createWebhook({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/webhooks`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createRedirect({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/redirects`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    createBlog({ commit }, blog) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${blog.landing_id}/blogs`, blog)
          .then((res) => resolve(res.data.blog))
          .catch((error) => reject(error))
      })
    },
    createPage({ commit }, page) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${page.landing.id}/pages`, page)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    resetStats({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/stats/reset`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    resetRedirect({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landingId}/redirects/${params.redirectId}/reset`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    update({ commit }, landing) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landing.id}`, landing)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    updateSettings({ commit }, landing) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landing.id}/settings`, landing)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    updateCustomUrl({ commit }, landing) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landing.id}/custom-url`, landing)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    updateWebhook({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landingId}/webhooks`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateRedirect({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landingId}/redirects`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landingId}/menus`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landingId}/forms`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updatePageRelations({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/page-relations`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateBlogSetting({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/blog-setting`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updatePodcastSetting({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landingId}/podcast-setting`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateBackupRecord({ commit }, record) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${record.landing_id}/backup-records/${record.id}`, record)
          .then((res) => resolve(res.data.backupRecord))
          .catch((error) => reject(error))
      })
    },
    updateEpisode({ commit }, episode) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${episode.landing.id}/episodes/${episode.id}`, episode)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateBlog({ commit }, blog) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${blog.landing.id}/blogs/${blog.id}`, blog)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    updatePage({ commit }, page) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${page.landing_id}/pages/${page.id}`, page)
          .then((res) => resolve(res.data.page))
          .catch((error) => reject(error))
      })
    },
    updatePageDesign({ commit }, page) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${page.landing.id}/pages/${page.id}/design`, page)
          .then((res) => resolve(res.data.shouldReload))
          .catch((error) => reject(error))
      })
    },
    convertNewEditor({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landingId}/convert-new-editor`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    setHomePage({ commit }, { landingId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/pages/${pageId}/set-home`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    publishPage({ commit }, { landingId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/pages/${pageId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    publishEpisode({ commit }, { landingId, episodeId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/episodes/${episodeId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    publishBlog({ commit }, { landingId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/blogs/${blogId}/publish`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    validateSubdomain({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/validate-subdomain`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    validateDomain({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/validate-domain`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    clone({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneAgencyBlog({ commit }, { landingId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/blog/${blogId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    cloneAgencyPage({ commit }, { landingId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/pages/${pageId}/clone`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    duplicate({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/duplicate`)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    importPodcast({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`landings/import-podcast`, data)
          .then(() => resolve(true))
          .catch((err) => reject(err))
      })
    },
    importXML({ commit }, data) {
      return new Promise((resolve, reject) => {
        axios
          .post(`landings/import-xml`, data)
          .then(() => resolve(true))
          .catch((err) => reject(err))
      })
    },
    importAdminBlog({ commit }, { landingId, uniqueId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/import/admin-blog/${uniqueId}/unique-id`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    importAgencyPage({ commit }, { landingId, uniqueId, params }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/import/agency-page/${uniqueId}/unique-id`, params)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    importAgencyBlog({ commit }, { landingId, uniqueId }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/import/agency-blog/${uniqueId}/unique-id`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    toggleAutomaticBackup({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landingId}/automatic-backup-option`)
          .then((res) => resolve(res.data.backupOption))
          .catch((error) => reject(error))
      })
    },
    instantBackup({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landingId}/instant-backup`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    restoreBackup({ commit }, record) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${record.landing_id}/backup-records/${record.id}/restore`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    remove({ commit }, landingId) {
      commit('loading', true)
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}`)
          .then(() => {
            commit('loading', false)
            resolve(true)
          })
          .catch((error) => {
            commit('loading', false)
            reject(error)
          })
      })
    },
    deleteWebhook({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landingId}/webhooks/${params.webhookId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteRedirect({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landingId}/redirects/${params.redirectId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteMenu({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landingId}/menus/${params.menuId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteForm({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landingId}/forms/${params.formId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteEpisode({ commit }, { landingId, episodeId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/episodes/${episodeId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteBlog({ commit }, { landingId, blogId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/blogs/${blogId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteBackupRecord({ commit }, record) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${record.landing_id}/backup-records/${record.id}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deleteContact({ commit }, { landingId, contactId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/contacts/${contactId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    deletePage({ commit }, { landingId, pageId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/pages/${pageId}`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    uploadFile({ commit }, { landingId, uploadForm }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/files`, uploadForm, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((res) => resolve(true))
          .catch((error) => reject(error))
      })
    },
    updateFile({ commit }, { landingId, file }) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landingId}/files/${file.id}`, file)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    deleteFile({ commit }, { landingId, fileId }) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${landingId}/files/${fileId}`)
          .then((res) => resolve(true))
          .catch((error) => reject(error))
      })
    },
    getKeywords({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/keywords`)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    addKeyword({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/keywords`, { names: params.names })
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    generateKeywordsWithAI({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/generate-keywords`, {
            prompt: params.prompt,
            agency_id: params.agency_id
          })
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },    
    removeKeyword({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landing_id}/keywords/${params.name}`)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
    generateAITitle({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/generate-title`, { name: params.name, agency_id: params.agency_id })
          .then((res) => resolve(res))
          .catch((error) => reject(error))
      })
    },
    generateAIBlog({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/generate-blog`, params)
          .then((res) => resolve(res))
          .catch((error) => reject(error))
      })
    },
    updatePrompts({ commit }, landing) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${landing.id}/prompts`, landing)
          .then((res) => resolve(res.data.data))
          .catch((error) => reject(error))
      })
    },
  },
  getters: {}
}